module.exports = __webpack_public_path__ + "img/completion.7bf6b133.jpg";